import { useTranslation } from 'react-i18next';
import { InfiosContainer, InfiosTextBlock } from '@infios/uikit/react';
import type { UnsupportedRequestData } from '../../interfaces/chat';
import styles from './ContentBlocks.module.css';

interface UnsupportedRequestBlockProps {
  data: UnsupportedRequestData;
}

export function UnsupportedRequestBlock({ data }: UnsupportedRequestBlockProps) {
  const { t } = useTranslation();
  const reasonKey =
    data.reason === 'read_only' || data.reason === 'out_of_scope'
      ? `ChatbotUI.OrderBlocks.UnsupportedReason_${data.reason}`
      : undefined;

  return (
    <InfiosContainer type="card">
      <InfiosTextBlock slot="header" weight="bold">
        {t('ChatbotUI.OrderBlocks.UnsupportedHeading')}
      </InfiosTextBlock>
      {reasonKey ? <p className={styles.row}>{t(reasonKey)}</p> : null}
    </InfiosContainer>
  );
}
